module.exports = __webpack_public_path__ + "img/staff.1b70e7f9.png";